import React, { useState } from "react";
import AddBannerPage1 from "./pages/AddBannerPage1";
import AddBannerPage2 from "./pages/AddBannerPage2";
import { useHistory } from "react-router-dom";

const AddBanners = ({ banner }) => {
  // controla em qual etapa o usuário está
  // page1 = dados principais
  // page2 = upload das imagens
  const [pageState, setPageState] = useState({
    page: "page1",
    // se existir banner, entra em modo edição
    bannerData: banner || null,
  });

  const history = useHistory();

  const [bannerData, setBannerData] = useState(banner || null);

  const [uploads, setUploads] = useState([
    {
      id: "desktop",
      displayed_screen: "activity_screen",
      device: "desktop",
      size: "1410x185",
      file: null,
    },
    {
      id: "desktop_full",
      displayed_screen: "activity_screen",
      device: "desktop",
      size: "900x180",
      file: null,
    },
    {
      id: "tablet",
      displayed_screen: "activity_screen",
      device: "tablet",
      size: "750x180",
      file: null,
    },
    {
      id: "mobile",
      displayed_screen: "activity_screen",
      device: "mobile",
      size: "342x170",
      file: null,
    },
    {
      id: "desktop_mobile",
      displayed_screen: "panel",
      device: "desktop",
      size: "392x165",
      file: null,
    },
  ]);

  const handleCancel = () => {
    history.push("/admin/banners");
  };

  // avança para página 2 e salva os dados preenchidos
  const nextPage = (data) => {
    setPageState((prev) => ({
      ...prev,
      page: "page2",

      // mantém os dados anteriores + novos dados do formulário
      bannerData: {
        ...prev.bannerData,
        ...data,
      },
    }));
  };

  const backPage = (data) => {
    setPageState((prev) => ({
      ...prev,
      page: "page1",
    }));
  };

  return (
    <>
      {/* primeira etapa do cadastro */}
      <div style={{ display: pageState.page === "page1" ? "block" : "none" }}>
        <AddBannerPage1
          nextPage={nextPage}
          handleCancel={handleCancel}
          bannerData={pageState.bannerData}
        />
      </div>
      {/* segunda etapa: upload das imagens */}
      <div style={{ display: pageState.page === "page2" ? "block" : "none" }}>
        <AddBannerPage2
          handleCancel={handleCancel}
          setUploads={setUploads}
          uploads={uploads}
          bannerData={pageState.bannerData}
          backPage={backPage}
        />
      </div>
    </>
  );
};

export default AddBanners;
